import React from 'react';
import './PlayButton.css';

interface PlayButtonProps {
  isPlaying: boolean;
  isLoading: boolean;
  hasError: boolean;
  onToggle: () => Promise<void>;
}

const PlayButton: React.FC<PlayButtonProps> = React.memo(({ isPlaying, isLoading, hasError, onToggle }) => {

  return (
    <button
      className={`play-button ${isPlaying ? 'playing' : ''} ${isLoading ? 'loading' : ''} ${hasError ? 'error' : ''}`}
      onClick={onToggle}
      aria-label={isPlaying ? 'Остановить воспроизведение' : 'Начать воспроизведение'}
      disabled={isLoading && !isPlaying}
      title={hasError ? 'Ошибка подключения. Попробуйте еще раз.' : (isPlaying ? 'Пауза' : 'Воспроизвести')}
    >
      <div className="play-button-circle">
        {isLoading ? (
          <div className="play-button-loader"></div>
        ) : hasError ? (
          <svg 
            className="play-button-icon" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Иконка обновления при ошибке */}
            <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" fill="currentColor" />
          </svg>
        ) : (
          <svg 
            className="play-button-icon" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            {isPlaying ? (
              // Иконка паузы
              <>
                <rect x="7" y="3" width="3.5" height="19" rx="0.5" fill="currentColor" />
                <rect x="13.5" y="3" width="3.5" height="19" rx="0.5" fill="currentColor" />
              </>
            ) : (
              // Иконка play (треугольник) - более крепкий и крупный
              <path d="M8 3v18l12-9z" fill="currentColor" stroke="currentColor" strokeWidth="0.5" />
            )}
          </svg>
        )}
      </div>
    </button>
  );
});

PlayButton.displayName = 'PlayButton';

export default PlayButton;
